import { Stack } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { Params, useParams } from "react-router";

import { EditCarForm } from "@/components/forms/EditCarForm";
import { useUpdateCar } from "@/services/cars/update-car";
import { showCustomNotification } from "@/utils/notifications";

import type { UpdateCarInput } from "@/services/cars/update-car";
import type { Car } from "@/types/car";
import type { MantineStyleProps } from "@mantine/core";
import type { FC } from "react";

export type UpdateCarProps = {
  autoCloseDelay?: boolean | number;
  car: Car;
  onClose?: () => void;
  onSuccess?: () => void;
} & MantineStyleProps;

export const UpdateCar: FC<UpdateCarProps> = ({
  autoCloseDelay = false,
  car,
  onClose,
  onSuccess,
  ...props
}) => {
  const { t } = useTranslation();
  const { garageId } = useParams() as Params;
  const { mutate, isPending } = useUpdateCar({
    mutationConfig: { onSuccess: handleSuccess, onError: handleError },
  });

  function handleSuccess() {
    showCustomNotification({
      title: t("components.UpdateCar.success.title"),
      message: t("components.UpdateCar.success.message"),
      /* actionButton: onSuccess
        ? {
            text: t("components.UpdateCar.success.action"),
            action: () => {
              onSuccess();
              hide();
            },
          }
        : undefined, */
      autoClose: autoCloseDelay,
    });
    onClose?.();
  }

  function handleError() {
    showCustomNotification({
      title: t("components.UpdateCar.error.title"),
      message: t("components.UpdateCar.error.message"),
      autoClose: autoCloseDelay,
    });
  }

  function handleSubmit(values: UpdateCarInput) {
    const filteredValues = { ...values, status: undefined };
    mutate({
      data: filteredValues,
      carId: car.identifier,
      garageId: garageId,
    });
  }

  const initialValues: Partial<UpdateCarInput> = {
    nickname: car.nickname,
    owner: car.owner,
    purchase_price: car.purchase_price,
    purchase_date: car.purchase_date,
    interior_colors: car.interior_colors,
    licence_plate: car.licence_plate,
    country_of_registration: car.country_of_registration,
    color: car.color,
    condition: car.condition,
    number_of_previous_owner: car.number_of_previous_owner,
    special_equipment: car.special_equipment,
    vin: car.vin,
  };

  return (
    <Stack {...props}>
      <EditCarForm
        loading={isPending}
        onCancel={onClose}
        onSubmit={handleSubmit}
        initialValues={initialValues}
        labels={{
          submitButton: t("components.CreateCarForm.editSubmitButton"),
        }}
      />
    </Stack>
  );
};
